import { shopVisitorsCRUDUrl, shopVisitorsUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getProductVisitors = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(shopVisitorsUrl + "?page_size=20&" + query ?? "", config);

    return response;
};

export const patchProductVisitorsNote = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(shopVisitorsCRUDUrl + "/" + id + "/", data, config);
    return response;
};
